export default __webpack_public_path__ + "static/media/package.1f454d34.png";